/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var n = /^-?(\d+(\.\d+)?)\s*((px)|(pt))?$/i,
    t = "screenUtils.toPt: input not recognized!",
    r = 96;

function u(n) {
  return n ? n / 72 * r : 0;
}

function e(n) {
  return n ? 72 * n / r : 0;
}

function o(r) {
  if ("string" == typeof r) {
    var _u = r.match(n);

    if (_u) {
      var _n = Number(_u[1]),
          _t = _u[3] && _u[3].toLowerCase(),
          _o = "-" === r.charAt(0),
          _c = "px" === _t ? e(_n) : _n;

      return _o ? -_c : _c;
    }

    return console.warn(t), null;
  }

  return r;
}

function c() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return {
    x: n,
    y: t
  };
}

function i() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return [n, t];
}

function f() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return {
    x: n,
    y: t
  };
}

function s() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return y([n, t]);
}

function x() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return p([n, t, r]);
}

function y(n) {
  return n;
}

function p(n) {
  return n;
}

function l(n) {
  return n;
}

function a(n, t) {
  return t ? (t.x = n[0], t.y = n[1], t) : {
    x: n[0],
    y: n[1]
  };
}

function d(n, t) {
  return t ? (t[0] = n.x, t[1] = n.y, t.length > 2 && (t[2] = 0), t) : [n.x, n.y];
}

export { y as castRenderScreenPointArray, p as castRenderScreenPointArray3, l as castScreenPointArray, f as createRenderScreenPoint, s as createRenderScreenPointArray, x as createRenderScreenPointArray3, c as createScreenPoint, i as createScreenPointArray, u as pt2px, e as px2pt, a as screenPointArrayToObject, d as screenPointObjectToArray, o as toPt };